import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const PrintIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={circled ? '60%' : '100%'}
      height={circled ? '60%' : '100%'}
      viewBox="0 0 23.7 22"
    >
      <g transform="translate(1 1)">
        <path
          d="M1288.832,148.176h-5.353v-7.044a3.628,3.628,0,0,1,3.62-3.636h14.46a3.628,3.628,0,0,1,3.62,3.636v7.044h-5.361"
          transform="translate(-1283.479 -131.5)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <rect
          width="10.85"
          height="5.996"
          transform="translate(5.426)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <rect
          width="10.85"
          height="6.975"
          transform="translate(5.426 13.025)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <line
          transform="translate(3.54 9.56)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  </CircledIcon>
);
